import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { DEFAULT_VALUE } from 'site-modules/shared/components/inventory/ev-insights/ev-insights-constants';
import { AccordionItem } from 'site-modules/shared/components/inventory/accordion/accordion-item/accordion-item';

import './ev-accordion-item.jsx.scss';

export function EvAccordionItem({ summaryTitle = null, summaryValue = null, description = null, ...restParams }) {
  return (
    <li className={classnames('ev-accordion-item', { 'disable-marker': !description })}>
      <AccordionItem
        {...restParams}
        summary={
          <div className="d-flex justify-content-between fw-normal text-cool-gray-40 pe-1">
            {summaryTitle}
            <span
              className={classnames('text-cool-gray-30 ms-0_5 align-self-center', {
                'fw-bold': summaryValue !== DEFAULT_VALUE,
              })}
            >
              {summaryValue}
            </span>
          </div>
        }
        noIcon={!description}
      >
        {description && <div className="medium my-1">{description}</div>}
      </AccordionItem>
    </li>
  );
}

EvAccordionItem.propTypes = {
  summaryTitle: PropTypes.string,
  summaryValue: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
